export default {
  state: {
    loading: false,
    uploading: false,
    error: null,
    progress: 0
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload
    },
    setUpLoading(state, payload) {
      state.uploading = payload
    },
    setProgress(state, payload) {
      state.progress = payload
    },
    setError(state, payload) {
      state.error = payload
    },
    clearError(state) {
      state.error = null
    }
  },
  actions: {
    clearError({ commit }) {
      commit('clearError')
    }
  },
  getters: {
    loading(state) {
      return state.loading
    },
    uploading(state) {
      return state.uploading
    },
    progress(state) {
      return state.progress
    },
    error(state) {
      return state.error
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/share/index.js